import TranslateIcon from "@mui/icons-material/Translate";
import {
    Chip,
    CircularProgress,
    Grid,
    MenuItem,
    Stack,
    Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CustomDropDown from "../../../../components/CutomDropDown";
import Label from "../../../../components/Label";
import TextInput from "../../../../components/TextInputs";
import { PACKAGE_USAGE_TYPE } from "../../../../constants/Variables";
import globalStyle from "../../../../globalStyle";

export const BasicInformation = ({
  inputValues,
  inputError,
  isLoading,
  allCategories,
  allSubCategories,
  allSubSubCategories,
  handleChangeValues,
  handleTranslateToEnglish,
}) => {
  const { t } = useTranslation();
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <Grid container spacing={2}>

      {/* Heading for basic information */}
      <Grid item md={12}>
        <Typography fontWeight={600} fontSize={20}>
          {t("supplierProductTab.basicInformation")}
        </Typography>
      </Grid>

      {/* Package name in Romanian */}
      <Grid item xs={12} md={12}>
        <Label
          labelText={t("supplierProductTab.packageNameInRomanian")}
          required
          htmlFor={"base-package-name-ro"}
        />
        <TextInput
          id={`base-package-name-ro`}
          styleProps={globalStyle.textField}
          placeholder={t("supplierProductTab.enterPackageNameInRomanian")}
          required
          name={`name_ro`}
          value={inputValues.name_ro}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.name_ro)}
          helperText={t(inputError.name_ro)}
        />
      </Grid>

      {/* Package name in English */}
      <Grid item xs={12} md={12}>
        <Stack
          mb={"5px"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Label
            labelText={t("supplierProductTab.packageNameInEnglish")}
            required
            htmlFor={"base-package-name-en"}
          />
          <Chip
            label={t("common.translateToEnglish")}
            size="small"
            onClick={() =>
              handleTranslateToEnglish("name_ro", "name_en")
            }
            icon={
              isLoading.translateToEnglish ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <TranslateIcon />
              )
            }
            disabled={isLoading.translateToEnglish}
          />
        </Stack>
        <TextInput
          id={`base-package-name-en`}
          styleProps={globalStyle.textField}
          placeholder={t("supplierProductTab.enterPackageNameInEnglish")}
          required
          name={`name_en`}
          value={inputValues.name_en}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.name_en)}
          helperText={t(inputError.name_en)}
        />
      </Grid>

      {/* Solution type */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("supplierProductTab.solutionType")}
          required
          htmlFor={"base-package-solution-type"}
        />
        <CustomDropDown
          id={"base-package-solution-type"}
          name="solutionType"
          value={inputValues.solutionType}
          onChange={handleChangeValues}
          selectError={Boolean(inputError.solutionType)}
          helperText={t(inputError.solutionType)}
          multiple
        >
          <MenuItem value="" disabled>
            {t("supplierProductTab.selectSolutionType")}
          </MenuItem>
          {PACKAGE_USAGE_TYPE.map((item, index) => (
            <MenuItem key={index} value={item.value}>
              {item.label[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("supplierProductTab.category")}
          required
          htmlFor={"base-package-category"}
        />
        <CustomDropDown
          id={"base-package-category"}
          name={"category"}
          value={inputValues.category}
          onChange={handleChangeValues}
          selectError={Boolean(inputError.category)}
          helperText={t(inputError.category)}
          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("supplierProductTab.selectCategory")}
          </MenuItem>
          {allCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Sub category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("supplierProductTab.filterBySubCategory")}
          htmlFor={"base-package-sub-category"}
        />
        <CustomDropDown
          id={"base-package-sub-category"}
          name={"subCategory"}
          value={inputValues.subCategory}
          onChange={handleChangeValues}

          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("supplierProductTab.selectSubCategory")}
          </MenuItem>
          {allSubCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Sub sub category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("supplierProductTab.filterBySubSubCategory")}
          htmlFor={"base-package-sub-sub-category"}
        />
        <CustomDropDown
          id={"base-package-sub-sub-category"}
          name={"subSubCategory"}
          value={inputValues.subSubCategory}
          onChange={handleChangeValues}
          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("supplierProductTab.selectSubSubCategory")}
          </MenuItem>
          {allSubSubCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>
    </Grid>
  );
};
